import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap JS
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/global.css';
import router from "./router/router";

const app = createApp(App);
app.use(router);
app.mount("#app");
